import { Editor } from '@tiptap/react';

export interface PickColorOptions {
  editor: Editor | null;
  color: string;
  mark?: {
    name: string;
    attribute: string;
  };
  update?: {
    name: string;
    attribute: string;
  };
  setRecentColor: (color: string) => void;
}

export function pickColor(options: PickColorOptions) {
  const { editor, color, mark, update, setRecentColor } = options;
  if (!editor) {
    return;
  }

  const { to } = editor.state.selection;

  editor.view.dom.focus({ preventScroll: true });

  if (mark) {
    editor
      .chain()
      .setMark(mark.name, { [mark.attribute]: color })
      .run();
  } else if (update) {
    editor
      .chain()
      .updateAttributes(update.name, { [update.attribute]: color })
      .run();
  }

  // 色を選択直後にクリックした箇所にフォーカスをあてる
  editor.commands.setTextSelection({ from: to, to: to });

  setRecentColor(color);
}

export function pickFontColor(
  editor: Editor | null,
  color: string,
  setRecentFontColor: (color: string) => void,
) {
  pickColor({
    editor,
    color,
    mark: { name: 'textStyle', attribute: 'color' },
    setRecentColor: setRecentFontColor,
  });
}

export function pickBgColor(
  editor: Editor | null,
  color: string,
  setRecentBgColor: (color: string) => void,
) {
  pickColor({
    editor,
    color,
    mark: { name: 'textStyle', attribute: 'backgroundColor' },
    setRecentColor: setRecentBgColor,
  });
}

export function pickCellColor(
  editor: Editor | null,
  color: string,
  setRecentCellColor: (color: string) => void,
) {
  pickColor({
    editor,
    color,
    update: { name: 'tableCell', attribute: 'stainedColor' },
    setRecentColor: setRecentCellColor,
  });
}
